module.exports = __webpack_public_path__ + "img/KSC05987.8babd6d5.jpg";